import {GCPortalkarteClass} from "./class_portalkarte";

export class GCPortalkarteGeocoderResponseClass {

    private portalmap: GCPortalkarteClass;
    private jquery: any;
    private proj4: any;
    private ol: any;

    private map: any;

    private readonly response: any;

    public constructor(pmap: GCPortalkarteClass, response: any) {
        this.portalmap = pmap;
        this.jquery = window['jQuery'] || null;
        this.ol = window['ol'] || null;
        this.proj4 = window['proj4'] || null;
        this.map = pmap.getMap();
        this.response = response;
    }

    /**
     *
     */
    public process() {
        if (this.response && this.response.detailMode) {
            if (this.response.resultList) {
                this.processDetail(this.response.resultList[0])
            }
        }
    }

    /**
     *
     * @param {any} hit result-Objekt des GeoCoder
     * @private
     */
    private processDetail(hit: any) {
        //console.log(hit);
        switch (hit.featuretype) {
            case 'landparcel': // Flurstücke als Polygon/Multipolygon einzeichen ...
                this.processFlurstueck(hit);
                break;
            case 'address':
            default:
                this.processPoint(hit);
        }
    }

    /**
     *
     * @param {any} hit
     * @private
     */
    private processFlurstueck(hit: any) {

        let test:any = this.portalmap.getLayerByName('responseLayer');
        if (test)
        {
            this.map.removeLayer(test);
        }

        let MultiPolygonStyle: any = new this.ol.style.Style({
            stroke: new this.ol.style.Stroke({
                color: 'red',
                width: 2,
            }),
            fill: new this.ol.style.Fill({
                color: 'rgba(255, 0, 0, 0.1)',
            }),
        })

        let vectorSource = new this.ol.source.Vector({});
        let reader = new this.ol.format.WKT();
        let feature = reader.readFeature(hit.geometry.wkt, {
            dataProjection: hit.geometry.crs,
            featureProjection: this.portalmap.getViewProjection()
        });
        feature.setStyle(MultiPolygonStyle);
        //console.log(feature);
        vectorSource.addFeature(feature);
        let vectorLayer = new this.ol.layer.Vector({
            source: vectorSource,
            idname: 'responseLayer'
        });
        this.map.addLayer(vectorLayer);
        this.map.getView().fit(feature.getGeometry());
    }

    /**
     *
     * @param {any} hit
     * @private
     */
    private processPoint(hit: any) {

        let test:any = this.portalmap.getLayerByName('responseLayer');
        if (test)
        {
            this.map.removeLayer(test);
        }

        let image = new this.ol.style.Circle({
            radius: 10,
            stroke: new this.ol.style.Stroke({
                color: 'red',
                width: 2,
            }),
            fill: new this.ol.style.Fill({
                color: 'rgba(255, 0, 0, 0.2)',
            }),
        });

        let PointStyle: any = new this.ol.style.Style({
            image: image
        })

        let vectorSource = new this.ol.source.Vector({});
        let reader = new this.ol.format.WKT();
        let feature = reader.readFeature(hit.geometry.wkt, {
            dataProjection: hit.geometry.crs,
            featureProjection: this.portalmap.getViewProjection()
        });
        feature.setStyle(PointStyle);
        //console.log(feature);
        vectorSource.addFeature(feature);
        let vectorLayer = new this.ol.layer.Vector({
            source: vectorSource,
            idname: 'responseLayer'
        });
        this.map.addLayer(vectorLayer);
        this.map.getView().fit(feature.getGeometry());

        // let test:any = this.portalmap.getLayerByName('responseLayer');
        // if (test)
        // {
        //     this.map.removeLayer(test);
        // }
        //
        // let coords: number[] = [hit.geometry.location.x, hit.geometry.location.y];
        // if (coords && hit.geometry.crs != this.portalmap.getViewProjection()) {
        //     //console.log('Punkt: Vor Transformation: ' + coords);
        //     coords = this.ol.proj.transform(coords, hit.geometry.crs, this.portalmap.getViewProjection());
        //     //console.log('Punkt: Nach Transformation: ' + coords);
        // }
        // this.map.getView().setCenter(coords);
    }

}